import { Pipe, PipeTransform } from '@angular/core';
import { DomSanitizer } from '@angular/platform-browser';

@Pipe({
  name: 'phoneLink'
})
export class PhoneLinkPipe implements PipeTransform {
  constructor(private domSanitizer: DomSanitizer) {}
  transform(value: string, ..._args: any[]): unknown {
    const phoneNumber: string = value;
    if(!phoneNumber) {
      console.error('No phone number provided');
      return;
    }

    // TODO: Add country code?
    const includesCountryCode = phoneNumber.startsWith('+1');
    const formattedNumber = (includesCountryCode ? '+' : '+1') + phoneNumber.replace(/\D/g, '');

    let link = `tel:${formattedNumber}`;
    return this.domSanitizer.bypassSecurityTrustUrl(link);
  }

}
